export const GROUND_PICKUP_RANGE = 120;

export type GroundPickupDrop = {
  id: string;
  itemId: string;
  quantity: number;
  ownerId: string | null;
  mapId: string;
  x: number;
  createdAt: number;
  freeAt: number;
  expiresAt: number;
};

export function nearestPickupDrop(
  drops: readonly GroundPickupDrop[],
  options: {
    mapId: string;
    playerX: number;
    playerId: string | null;
    nowMs: number;
    range?: number;
  },
): GroundPickupDrop | null {
  const range = options.range ?? GROUND_PICKUP_RANGE;
  return (
    drops
      .filter((drop) => {
        if (drop.mapId !== options.mapId || options.nowMs >= drop.expiresAt) return false;
        if (Math.abs(drop.x - options.playerX) > range) return false;
        return !drop.ownerId || drop.ownerId === options.playerId || options.nowMs >= drop.freeAt;
      })
      .sort((a, b) => {
        const distance = Math.abs(a.x - options.playerX) - Math.abs(b.x - options.playerX);
        if (distance !== 0) return distance;
        if (a.createdAt !== b.createdAt) return a.createdAt - b.createdAt;
        return a.id.localeCompare(b.id);
      })[0] ?? null
  );
}
